import { Route, Switch } from "react-router";
import { AppRouteUi } from "../../../config/appRoute";
import { PageInsuranceView } from "./pageInsuranceView";
import { RedirectRoute } from "../../../components/redirectRoute";
import { PageInsuranceAdd } from "./pageInsuranceAdd";
import { PageInsuranceUpdate } from "./pageInsuranceUpdate";

export function PageInsurance(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route
          path={AppRouteUi.Insurance.List()}
          exact
          component={PageInsuranceView}
        />
        <Route
          path={AppRouteUi.Insurance.Add()}
          exact
          component={PageInsuranceAdd}
        />
        <Route
          path={AppRouteUi.Insurance.Update()}
          exact
          component={PageInsuranceUpdate}
        />
        <RedirectRoute
          from={AppRouteUi.Insurance.Root()}
          to={AppRouteUi.Insurance.List()}
          wildcardOpt={{
            defaultTo404Page: true,
          }}
        />
      </Switch>
    </div>
  );
}
